import { TaxDto } from 'api/taxes/models/TaxDto';
import { UnitDto } from 'api/units/models/UnitDto';
import { LinesDataProvider } from 'screens/business/budgets/budget/lines/LinesDataProvider';
import BudgetLinesTable from 'screens/business/budgets/budget/lines/table/BudgetLinesTable';
import { BudgetsCacheData } from 'screens/business/budgets/budget/utils/BudgetsCache';

interface Props {
    type: 'create' | 'details' | 'edit' | 'version' | undefined;
    units: UnitDto[];
    taxes: TaxDto[];
    budgetData: BudgetsCacheData;
}

function BudgetComponentLines({ type, units, taxes, budgetData }: Props): JSX.Element | null {
    const isDetails = type === 'details' || type === 'version';

    return (
        <LinesDataProvider.Provider value={{ taxes, units, hiddenColumns: budgetData.hiddenColumns }}>
            <BudgetLinesTable
                disabled={isDetails}
            />
        </LinesDataProvider.Provider>
    );
}

export default BudgetComponentLines;
